import React from 'react';
import Data from './Data';
import { Button } from 'primereact/button';
import { getConstant } from '../../../utils/constants';

function UrlCard({ url, removeUrl }) {
  return (
    <div className="border border-black-300 p-3 rounded-md flex flex-row gap-3 items-center justify-between">
      <div className="flex flex-row gap-5 justify-start items-center">
        <i
          className={`pi ${getConstant('backoffice.residency.urlType', url.type).icon}`}
          style={{ fontSize: 20 }}></i>
        <Data key="label" label={'Label'} value={url.label} />
        <Data key="link" label={'URL'} value={url.link} large />
      </div>

      {removeUrl && (
        <Button icon="pi pi-trash" rounded severity="danger" onClick={removeUrl} outlined />
      )}
    </div>
  );
}

export default UrlCard;
